function modifyUrl(url) {
    let index = url.lastIndexOf('.');

    if (index === -1) return url;

    let modifiedUrl = url.slice(0, index) + '_80x' + url.slice(index);

    return modifiedUrl;
}

async function fetchData(link, type) {

    if(type == 'collection'){
        const response = await fetch(`${link}/products.json`);
        const result = await response.json();

        return result.products[0];
    }else{
        const response = await fetch(`${link}.json`);
        const result = await response.json();

        return result.product;
    }
}


window.addEventListener('DOMContentLoaded', () => {
    const linkImages = document.querySelectorAll('.product-link-img');

    const callback = (entries, observer) => {
        entries.forEach(async (entry) => {
        if (entry.isIntersecting) {
            
            if (entry.target.hasAttribute('data-image-loaded')) return;

            const link = entry.target.querySelector('a').getAttribute('href');
            let sourcetType = entry.target.querySelector('img').getAttribute('data-source-type');

            const data = await fetchData(link, sourcetType);
            
            if(data){
                const imageLink = modifyUrl(data?.image?.src || data?.images[0]?.src);

                entry.target.querySelector('img').setAttribute('src', imageLink);
                entry.target.setAttribute('data-image-loaded', '')
            }else{
                entry.target.querySelector('img').remove();
            }
            

        } else {
     
        }
        });
    };

    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };

    const observer = new IntersectionObserver(callback, options);

    linkImages.forEach(target => {
        observer.observe(target.parentNode);
    });
})